// Design System - Border Radius Scale

const borderRadius = {
    small: '8px',
    medium: '16px',
    large: '32px',
    full: '50%'
};

export default borderRadius;
